import { combineReducers } from 'redux';
import UserReducer from "./userReducer";
import CommonReducer from "./commonReducer";

const app = combineReducers({
    UserReducer,
    CommonReducer

});
export default app;